@for (payment of orderDetailsPayments; track payment.id) {
    <div class="row payment">
        <div class="col-6 d-flex align-items-center">
            <ng-container *ngTemplateOutlet="paymentMethod; context: { $implicit: payment }"></ng-container>
        </div>
        <ng-container *ngTemplateOutlet="paymentStatus; context: { $implicit: payment }"></ng-container>
    </div>

    @for (refund of payment.refunds; track $index) {
        <div class="row payment refund">
            <div class="col-8">
                <span class="payment-method-name fs-small">
                    {{
                        ('Order_Payment_Table.Refund_Label.' + refund.status | trans) | tags:[
                            {key: 'amount', value: (refund.amount | currency:payment.currency)}
                        ]
                    }}
                </span>
            </div>
            <div class="col-4 text-right">
                <div class="fs-small" [cm-tooltip]="refund.refundedAt | date:'EE d MMM y H:mm'">
                    {{ refund.refundedAt | date:'shortDate' }}
                </div>
            </div>
        </div>
    }
}

<ng-template #paymentMethod let-payment>
    <span
        [cm-tooltip]="payment.method"
        [ngClass]="['cm-payment', 'cm-icon', 'vertical-middle', getPaymentMethodSpecificClass(payment.method)]"
        aria-hidden="true">
    </span>
    <span class="payment-method-name">{{ payment.method }}<br></span>
</ng-template>

<ng-template #paymentStatus let-payment>
    <div class="col-6 text-right"
         [class.d-flex]="isRefreshableStatus(payment.status)"
         [class.align-items-center]="isRefreshableStatus(payment.status)"
         [class.justify-content-end]="isRefreshableStatus(payment.status)"
    >
        <div>
            <span
                [class.cl-success-color]="payment.status === 'SUCCESS'"
                [class.cl-error-color]="['CANCELLED', 'EXPIRED', 'FAILURE'].includes(payment.status)"
                [class.cl-warning-color]="payment.status === 'OPEN'">
                {{ payment.status }}
            </span>
        </div>
        @if (isRefreshableStatus(payment.status)) {
            <button class="btn btn-secondary-icon vertical-align-middle"
                    (click)="updatePaymentStatus(payment)">
                <span class="cm-icon cm-icon-refresh" aria-hidden="true"></span>
            </button>
        } @else {
            <div class="fs-small" [cm-tooltip]="payment.payedAt | date:'EE d MMM y H:mm'">
                {{ payment.balance | currency:payment.currency }} | {{ payment.payedAt | date:'shortDate' }}
            </div>
        }
    </div>
</ng-template>
